import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { LensUpstreamFlowsQuery, LensUpstreamFlowsQueryVariables, LensUpstreamFlowsQuery_lenses_upstreamFlowsConnection_nodes } from '../../../gen-src/queries/LensUpstreamFlowsQuery';
import { FlowSortOrder } from '../../../gen-src/queries/globalTypes';
import { LensUpstreamFlowsQueryGql } from '../../queries/LensUpstreamFlowsQueryGql';
import { FlowsDisplayGrid, FlowsDisplayGridRowData, getRowDataForFlow } from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = LensUpstreamFlowsQueryVariables;
type QueryResults = LensUpstreamFlowsQuery;
type QueryResultListNode = LensUpstreamFlowsQuery_lenses_upstreamFlowsConnection_nodes;
type GridRowData = FlowsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses[0] && resultData.lenses[0].upstreamFlowsConnection;
}

export type LensUpstreamFlowsQueryGridProps =
  GridSortProps<FlowsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export const LensUpstreamFlowsQueryGrid: React.FC<LensUpstreamFlowsQueryGridProps> = props => {
  const emptyGridMessage = Messages.EmptyUpstreamFlowsLineageGridMessage();

  return (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamFlowsQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as FlowSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForFlow}
    >
      {({ rowStore }) =>
        <FlowsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
};
